<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
              <el-form-item>
                <el-button type="success" v-if="parms === 'Kyzxfwgl'" @click="addfn()">添加</el-button>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="type" label="分类" width="150">
            <template slot-scope="scope">{{ scope.row.type | questionData()}}</template>
          </el-table-column>
          <el-table-column prop="question" label="问题"></el-table-column>
          <el-table-column prop="answer" label="选项"> </el-table-column>
          <el-table-column prop="addtime" label="添加时间" width="155">
            <template slot-scope="scope">{{(scope.row.addtime * 1000) | formatTime()}}</template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
              <el-button type="danger" @click="deletefn(11, 125, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button class="elbtn delete" @click="deletesfn(11, 118)">批量删除</el-button>
        <!-- <el-button type="primary" class="elbtn delete" @click="setIndexnews(11, 5)">设置首页信息</el-button> -->
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 李旭
 * 矿业展会列表
 */
import filters from '../method/filter'
import method from '../method/methods'
import {mapState} from 'vuex'
export default {
  mixins: [filters, method],
  data()
  {
    return {
      form: {
        id: null,
        ziduan: 'title',
        title: '',
        level: '',
        sort: '',
        count: 20,
        date: 'addtime',
        starttime: '',
        endtime: '',
        catid: null,
        ssgj: null
      },
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      show1: false,
      show2: false,
      show3: false,
      parms: '',
      newsInfo: [],
      options1: [
        { value: '选项1', label: '标题', key: 'title' },
        { value: '选项2', label: '关键词', key: 'tag' },
        { value: '选项3', label: '简介', key: 'introduce' }
      ],
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      result_data: [
        { value: '选项1', label: '添加时间降序', description: 'addtime DESC' },
        { value: '选项2', label: '添加时间升序', description: 'addtime ASC' },
        { value: '选项3', label: '更新时间降序', description: 'edittime DESC' },
        { value: '选项4', label: '更新时间升序', description: 'edittime ASC' },
        { value: '选项5', label: '浏览次数降序', description: 'hits DESC' },
        { value: '选项6', label: '浏览次数升序', description: 'hits ASC' },
        { value: '选项7', label: '信息ID降序', description: 'id DESC' },
        { value: '选项8', label: '信息ID升序', description: 'id ASC' }
      ],
      time_data: [
        { value: 'edittime', label: '更新日期' },
        { value: 'addtime', label: '发布日期' }
      ],
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ]
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.urlpath = window.location.href
    this.parms = this.urlpath.substring(this.urlpath.lastIndexOf('/') + 1)
    this.getList()
    if (this.parms === 'ToKyRelease')
    {
      this.show3 = true
      this.show1 = false
      this.show2 = false
    }
    if (this.parms === 'TokyExamine')
    {
      this.show1 = true
      this.show2 = false
      this.show3 = false
    }
    if (this.parms === 'Kyzhzxgl')
    {
      this.show2 = true
      this.show1 = false
      this.show3 = false
    }
  },
  methods: {
    //获取数据
    getList()
    {
      // let userInfo = JSON.parse(localStorage.getItem('userMsg'))
      let count = this.form.count
      let currentPage = this.currentPage
      // let ziduan = this.form.ziduan
      // let StartTime = this.form.starttime.valueOf() / 1000
      // let EndTime = this.form.endtime.valueOf() / 1000
      // let exp = ''
      // let reorder = ''
      // //循环筛选条件
      // for (let e in this.form)
      // {
      //   let item = this.form[e]
      //   if (item && e === 'title')
      //     exp += `A.${ziduan} like '%${item}%' and `
      //   if (item && e === 'level')
      //     exp += `A.level = '${item}' and `
      //   if (item && e === 'starttime' && item.valueOf() / 1000 !== 0)
      //   {
      //     if (this.form['date'] === 'addtime')
      //       exp += `A.addtime > ${StartTime} and A.addtime < ${EndTime} and `
      //     else
      //       exp += `A.edittime > ${StartTime} and A.edittime < ${EndTime} and `
      //   }
      //   if (item && e === 'catid' && item !== null)
      //     exp += `A.catid = ${item} and `
      //   if (item && e === 'ssgj' && item !== null)
      //     exp += `A.ssgj = ${item} and `
      //   if (item && e === 'sort')
      //     reorder = `${item}`
      // }
      // reorder = reorder ? reorder : `A.addtime DESC`
      // if (this.parms === 'Kyzxgl')
      //   exp = exp ? `${exp}A.id != 0` : 'A.id > 0'
      // else if (this.parms === 'TokyExamine')
      // {
      //   let exaary = userInfo.role.toString()
      //   if (exaary === '0')
      //     exp = exp ? `${exp}A.id != 0` : 'A.id > 0 and examine in (1,2,3)'
      //   else
      //     exp = exp ? `${exp}A.id != 0` : `A.id > 0 and examine in (${exaary})`
      // }
      // else if (this.parms === 'ToKyRelease')
      // {
      //   if (userInfo.role.indexOf(6) !== -1 || userInfo.role.indexOf(0) !== -1)
      //     exp = exp ? `${exp}A.id != 0` : 'A.id > 0 and examine = 5'
      // }
      // let paras = {cmd: 'queryUnion', _major: 11, _minor: 1, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: exp + ' and A.catid=B.id', init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: reorder}
      let exp = ''
      exp = 'id > 0 and type = 3'
      let paras = {cmd: 'query', _major: 11, _minor: 125, _exp: exp, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'id DESC'}

      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
        {
          this.countSum = ret[0].total
          this.tableData = []
          ret[0].data.forEach((item) =>
          {
            this.tableData.push({
              id: item.id,
              type: item.type,
              question: item.question,
              answer: item.answer,
              addtime: item.addtime
            })
          })
        }
      })
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/KyzxfwUpdate', query: {id: row.id}})
    },
    // 点击上移
    setup(row)
    {
      if (row.orders === 1)

        this.$message({message: '此条数据已是第一位，不能再次上移', type: 'error', customClass: 'mzindex'})
      else
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 118,
          _exp: 'orders=?',
          types: 'i',
          vals: row.orders - 1
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length > 0)
          {
            let obj = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 118,
              retAtt: 1,
              id: ret[0].id,
              orders: ret[0].orders + 1
            }
            window.post.getPost(obj)
            let objs = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 118,
              retAtt: 1,
              id: row.id,
              orders: row.orders - 1
            }
            window.post.getPost(objs).then((retss) =>
            {
              if (retss)
              {
                this.$message({message: '上移成功', type: 'success', customClass: 'mzindex'})
                this.getList()
              }
            })
          }
        })
      }
    },
    //点击审核
    look(row)
    {
      this.$router.push({path: '/KyzhLook', query: {id: row.id}})
    },
    release(row)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 118,
        retAtt: 1,
        id: row.id,
        examine: 0
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '发布失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '发布成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToRelease'})
          this.getList()
        }
      })
    },
    //设置首页信息
    setIndexnews(major, minor)
    {
      this.newsInfo = []
      let paras = {cmd: 'query', _major: major, _minor: minor, _exp: `id in (${this.multipleSelection})`}
      window.post.getPost(paras).then((ret) =>
      {
        ret.forEach(data =>
        {
          this.newsInfo.push({major: major, minor: minor, id: data.id, addtime: Date.parse(new Date()) / 1000, title: data.title, thumb: data.thumb, introduce: data.introduce, newsAddtime: data.addtime, typeid: data.catid})
        })
        this.addsinfo(this.newsInfo)
      })
    },
    //批量添加首页数据
    addsinfo(newsInfo)
    {
      let obj = {
        cmd: 'adds',
        _major: 11,
        _minor: 74,
        json: JSON.stringify(this.newsInfo)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$confirm('确定要将您选择的数据设置为前沿资讯头条?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() =>
          {
            this.$message({
              type: 'success',
              message: '设置成功!'
            })
            this.getList()
          }).catch(() =>
          {
            this.$message({
              type: 'info',
              message: '已取消设置'
            })
          })
        }
      })
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/CjwtLB.vue